import React, { useEffect } from 'react';
import ApiValidationErrorDisplay from '~/components/ApiValidationErrorDisplay';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { schema } from './alignment.yup';
import DisplayFormikState from '~/components/DisplayFormikState';
import SubmitResetButtons from '~/components/FormControl/SubmitResetButtons';
import classNames from 'classnames/bind';
const cx = classNames.bind();
import { Formik } from 'formik';
import { Card, Col, Row, Form } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { checkDuplicateName } from '~/utils/validators.yup';
import { API_PREFIX } from './alignment.api';
import ActiveRounds from '../components/ActiveRounds';
import ActiveTurns from '../components/ActiveTurns';
import { BasicInfo, AttackAndDefense, DiceValue, Point, HealthPoint, Others } from './FormGroup';
import { FormCombo, FormNumber, FormSelect } from '~/components/FormControl';
import { fetchCardMetaDataApi } from '../../CardSaga/cardMetaDataSlice';
import startCase from 'lodash/startCase';

AlignmentForm.propTypes = {
    initialValues: PropTypes.object.isRequired,
    setResetCount: PropTypes.func.isRequired,
    resetCount: PropTypes.number.isRequired,
    formSubmit: PropTypes.func.isRequired,
};

function AlignmentForm({ initialValues, setResetCount, formSubmit }) {
    const { isLoading } = useSelector((state) => state.loading);
    const { apiValidationErrors } = useSelector((state) => state.apiValidationError);
    const { cardMetaData } = useSelector((state) => state.cardSaga.cardMetaData);
    const { statuses } = cardMetaData;
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(statuses)) dispatch(fetchCardMetaDataApi());
    }, []);

    return (
        <>
            {!isEmpty(initialValues) && !isEmpty(cardMetaData) ? (
                <Card>
                    <Card.Body>
                        <Formik
                            initialValues={initialValues}
                            validateOnChange={false}
                            validationSchema={schema}
                            onSubmit={formSubmit}
                        >
                            {(props) => {
                                // eslint-disable-next-line react/prop-types
                                const { handleSubmit, isSubmitting, resetForm } = props;
                                const asyncApiCall = checkDuplicateName(initialValues.name, API_PREFIX);
                                // eslint-disable-next-line react/prop-types

                                return (
                                    <>
                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />
                                        <Row>
                                            <Col sm={4}>
                                                <BasicInfo asyncApiCall={asyncApiCall} />
                                            </Col>
                                            <Col sm={8}>
                                                {/* {'1st row'} */}
                                                <Row>
                                                    <Col sm={6}>
                                                        <AttackAndDefense />
                                                    </Col>

                                                    <Col sm={6}>
                                                        <DiceValue />
                                                    </Col>
                                                </Row>

                                                {/* {'2nd row'} */}
                                                <Row>
                                                    <Col sm={6}>
                                                        <Point />
                                                    </Col>

                                                    <Col sm={6}>
                                                        <HealthPoint />
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <ActiveRounds
                                                smCol={4}
                                                smCheckbox={4}
                                            />
                                            <ActiveTurns
                                                smCol={4}
                                                className="justify-content-around"
                                            />
                                            <Col sm={4}>
                                                <Others />
                                            </Col>
                                        </Row>

                                        <BoonEffects
                                            name="boonEffects"
                                            title={startCase('boonEffects')}
                                            options={statuses || []}
                                        />

                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />

                                        <ApiValidationErrorDisplay
                                            errors={apiValidationErrors}
                                            clearError={clearApiValidationErrors}
                                        />
                                        <DisplayFormikState props={props} />
                                    </>
                                );
                            }}
                        </Formik>
                    </Card.Body>
                </Card>
            ) : (
                <Card style={{ position: 'relative' }}>
                    <Card.Body className={cx('row', { whirl: isLoading })}></Card.Body>
                </Card>
            )}
        </>
    );
}

const withFormCombo = (FormCombo) => {
    // eslint-disable-next-line react/prop-types, react/display-name
    return ({ name, title, options }) => {
        const renderFunc = (index, defaultValue1) => {
            return (
                <Form.Row>
                    <FormSelect
                        name={`${[name]}.${index}.status`}
                        label={title}
                        options={options}
                        defaultValue={defaultValue1}
                        sm={6}
                    />
                    <FormNumber
                        name={`${[name]}.${index}.statusVal`}
                        label={'Value'}
                        sm={6}
                    />
                </Form.Row>
            );
        };

        return (
            <FormCombo
                sm={4}
                name={name}
                headerClass="bg-info"
                renderFunc={renderFunc}
                options={options}
                title={startCase('boonEffects')}
                valueObj={{
                    status: '',
                    statusVal: '',
                }}
                wrapperClass="mt-3"
            ></FormCombo>
        );
    };
};

const BoonEffects = withFormCombo(FormCombo);

export default AlignmentForm;
